<template>
  <div class="container-center">
    <!-- 公共头部 -->
    <home-header></home-header>
    <!-- banner  -->
    <div class="banner-info"></div>
    <div class="content-wrap">
      <img src="../../assets/images/rencai/college.jpg"/>
    </div>
    <!-- 公共版权 -->
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/homeFooter";

export default {
  name: "",
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style scoped>
.banner-info {
  width: 100%;
  height: 200px;
  background: url(../../assets/images/banner002.png);
  background-size: 100% 100%;
}

.content-wrap {
  width: 95%;
  margin: 0 auto;
  padding: 30px 0;
}

.content-wrap img {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/pages/education/collegePage.vue